import styled from '@emotion/styled';

const MyDiv = styled.div`
.txt{
  color:rgba(0, 0, 0, 1)
}
.card-wrapper{
  position: relative;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  padding: 3rem 1rem 1rem;

  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: all 0.2s;
    &:hover {
    box-shadow: 0 4px 6px rgba(0,0,0,0.15);
    // transform: translateY(-2px);
  }
}

`;
export default MyDiv